export default __webpack_public_path__ + "static/media/11.ca1f245d.jpg";